import { useEffect, useState } from "react";
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";


export interface IUseCommentInputPanel {
    onPostCommentClick: ()=>void,
    commentString: string,
    setCommentString: (commentString: string)=>void,
    setShowCommentFunctionality: (show: boolean)=>void,
}

const UseCommentInputPanel = ({onPostCommentClick, commentString, setCommentString, setShowCommentFunctionality}: IUseCommentInputPanel) => {
    const [commentStringIsInvalid, setCommentStringIsInvalid] = useState<boolean>(false);
    const placeholderText = "Add a comment...";
    const cancelContentText = "Cancel";
    const confirmContentText = "Comment";
    const cancelAriaLabel = "Cancel and do not add comment.";
    const confirmAriaLabel = "Confirm and add comment to content";

    useEffect(() => {
        setCommentStringIsInvalid(commentString.trim().length === 0);
    }, [commentString]);

    function onCancelClick(e: React.MouseEvent<HTMLButtonElement>) {
        useHaltPropagation(e);
        setCommentString("");
        setShowCommentFunctionality(false);
    }

    function onConfirmClick(e: React.MouseEvent<HTMLButtonElement>) {
        useHaltPropagation(e);
        if (!commentStringIsInvalid) {
            onPostCommentClick();
        }
    }

    return {
        commentStringIsInvalid, onCancelClick, onConfirmClick, placeholderText, cancelContentText, cancelAriaLabel, confirmAriaLabel, confirmContentText
    };
};

export default UseCommentInputPanel